<div class="daisy-card bg-base-100 border mt-4 shadow-lg rounded-lg transition-all duration-300" [class]="borderClass" [class.border-warning]="!isAccessible">
  <div class="daisy-card-body p-4 sm:p-5 md:p-6">
    <div class="flex flex-col sm:flex-row justify-between items-start sm:items-center gap-4">
      <div class="flex items-start gap-3 min-w-0 flex-1">
        <!-- Status indicator dot (similar to sessions tab) -->
        <div
          class="w-3 h-3 rounded-full mt-1.5 shrink-0"
          [class.bg-success]="isAccessible"
          [class.bg-warning]="!isAccessible"
          [title]="isAccessible ? 'Accessible Recording' : 'Restricted Recording'"
        ></div>

        <div class="min-w-0 flex-1">
          <div class="flex flex-wrap items-center gap-2 mb-1">
            <h2 class="text-lg sm:text-xl font-bold text-base-content break-words leading-snug">
              {{ sessionTitle }}
            </h2>

            <!-- Access Status Badge -->
            @if (!isAccessible) {
              @if (resourceAccess.isRestrictedBySinglePass) {
                <span class="daisy-badge daisy-badge-warning daisy-badge-sm font-semibold gap-1">
                  <i class="fa-solid fa-lock text-xs"></i>
                  Single Pass Required
                </span>
              } @else if (resourceAccess.isPending) {
                <span class="daisy-badge daisy-badge-warning daisy-badge-sm font-semibold gap-1">
                  <i class="fa-solid fa-clock text-xs"></i>
                  Verification Pending
                </span>
              } @else {
                <span class="daisy-badge daisy-badge-ghost daisy-badge-sm font-semibold gap-1 border-warning/40 text-warning">
                  <i class="fa-solid fa-lock text-xs"></i>
                  Subscription Required
                </span>
              }
            }
          </div>

          <p class="text-sm text-base-content/70 mb-1 break-words">
            In
            <a
              href="/live-classes/{{ session?.liveClass?.id }}"
              class="font-medium text-primary hover:underline"
            >
              {{ session?.liveClass?.title }}
            </a>
          </p>

          @if (session?.meetingId) {
          <h6 class="text-sm text-base-content/60">
            <i class="fas fa-calendar-alt mr-1"></i>
            {{ sessionDate | date: 'mediumDate' }}
          </h6>
          } @else {
          <h6 class="text-sm text-base-content/60">
            <i class="fas fa-layer-group mr-1"></i>
            All Sessions
          </h6>
          }
        </div>
      </div>

      <div class="flex flex-row items-center gap-2 shrink-0 self-end sm:self-center">
        @if (isAccessible) {
          <button
            (click)="playVideo(sessionId)"
            [disabled]="!isUploadComplete"
            class="daisy-btn daisy-btn-primary daisy-btn-circle"
            title="Play Video"
          >
            <i class="fas fa-play"></i>
          </button>
        } @else {
          <button
            disabled
            class="daisy-btn daisy-btn-circle daisy-btn-ghost bg-base-200 cursor-not-allowed opacity-60 text-warning"
            title="Access Restricted - Requires Valid Subscription or Session Pass"
          >
            <i class="fas fa-lock"></i>
          </button>
        }

        @if (showDeleteButton) {
        <black-confirm-dialog
          confirmBtnLevel="danger"
          bodyText="Are you sure you want to proceed? This action is irreversible."
          (confirm)="deleteRecording(sessionId)"
        >
          <button
            *blackConfirmDialogTrigger="let toggle = toggle"
            (click)="toggle()"
            class="daisy-btn ml-2 sm:ml-4 hover:daisy-btn-error daisy-btn-sm sm:daisy-btn-md"
            title="Delete Recording"
          >
            <i class="fas fa-trash-alt"></i>
            <span class="ml-2">Delete</span>
          </button>
        </black-confirm-dialog>
        }
      </div>
    </div>
    @if (uploadSession$) {
    <div class="mt-4">
      <black-file-upload [uploadSession]="uploadSession$"></black-file-upload>
    </div>
    }
    @if (isPolling) {
    <div class="mt-4">
      <div class="daisy-card daisy-card-bordered bg-base-100">
        <div class="daisy-card-body py-3">
          <div class="flex items-center gap-3">
            <span class="daisy-loading daisy-loading-spinner daisy-loading-sm text-primary"></span>
            <span class="text-sm text-base-content/70">Uploading in background…</span>
          </div>
          <progress class="daisy-progress daisy-progress-primary w-full"></progress>
        </div>
      </div>
    </div>
    }
    @if (isUploadFailed) {
    <div class="daisy-alert daisy-alert-error text-sm mt-4">
      <i class="fas fa-exclamation-circle"></i>
      Upload failed. Please delete this entry and try adding the recording again.
    </div>
    }
  </div>
</div>
